import { useEffect, useState } from "react";
import classNames from "classnames";
import { isEmpty } from "lodash";
import Modal from "../../Modal";
import { EMPTY_STRING, MODAL_SIZE, QUESTION_MARK } from "../../../../constants";
import { renderExpression } from "../../../../helpers";

const ASTRICK = "*";
const PER_FIVE_MINUTES = "0/5";
const { LG } = MODAL_SIZE;

const CronExpressionModal = ({
  cronFrequency,
  cronExpression,
  setCronExpression,
  show,
  onClose,
  setFieldValue,
}) => {
  const [frequency, setFrequency] = useState({
    minute: PER_FIVE_MINUTES,
    hour: ASTRICK,
    day: ASTRICK,
    month: ASTRICK,
    week: QUESTION_MARK,
    year: ASTRICK,
  });
  const [expression, setExpression] = useState(EMPTY_STRING);

  useEffect(() => {
    if (!isEmpty(cronFrequency)) setFrequency(cronFrequency);
  }, [cronFrequency]);

  useEffect(() => {
    if (cronExpression) setExpression(cronExpression);
  }, [cronExpression]);

  const handleSubmit = () => {
    setFieldValue("frequency", frequency);
    setCronExpression(expression);
    onClose();
  };

  const isFrequencyFieldsInValid =
    Object.values(frequency).includes(EMPTY_STRING);

  const dayOrWeekInputValid =
    frequency.day === QUESTION_MARK || frequency.week === QUESTION_MARK;

  useEffect(() => {
    const { day, hour, minute, month, week, year } = frequency;
    if (!isFrequencyFieldsInValid)
      setExpression(`${minute} ${hour} ${day} ${month} ${week} ${year}`);
  }, [frequency, isFrequencyFieldsInValid, setExpression]);

  const footer = (
    <div className="p-6 border-t border-gray-700 flex align-center justify-end">
      <button
        className="btn btn-primary-light mr-1"
        type="button"
        onClick={onClose}
      >
        Close
      </button>
      <button
        type="button"
        onClick={handleSubmit}
        disabled={!dayOrWeekInputValid || isFrequencyFieldsInValid}
        className="btn btn-primary"
      >
        Save
      </button>
    </div>
  );

  return (
    <>
      <Modal
        title="Customize Cron Expression"
        footer={footer}
        handleClose={onClose}
        shouldOpen={show}
        size={LG}
      >
        <div className="p-6 border-b border-gray-700 flex">
          {Object.keys(frequency).map((name) => (
            <div key={name.toString()}>
              <input
                key={name.toString()}
                type="text"
                name={name}
                className="form-control border-2 w-20 flex-1 mx-1 mt-2"
                value={frequency[name]}
                onChange={(event) =>
                  setFrequency({
                    ...frequency,
                    [name]: event.target.value,
                  })
                }
                placeholder={name}
              />
              <label className="text-gray-50 text-sm font-bold flex-1 mr-1 ml-2">
                {name}
              </label>
            </div>
          ))}
        </div>
        <div className="flex items-center p-6 border-b border-gray-700">
          <h6 className={classNames("text-base text-gray-50 font-bold ml-1")}>
            {renderExpression(
              expression,
              dayOrWeekInputValid,
              isFrequencyFieldsInValid
            )}
          </h6>
        </div>
      </Modal>
    </>
  );
};

export default CronExpressionModal;
